/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDetailShipping_shipment$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespShippingReturns_shipment$ref: FragmentReference;
export type PdpRespShippingReturns_shipment = {|
  +$fragmentRefs: PdpSharedDetailShipping_shipment$ref,
  +$refType: PdpRespShippingReturns_shipment$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipment",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '068d48c4fa1782a753ba69b4f347427d';
module.exports = node;
